var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors,
    borders = _ref.borders;
  return {
    createButtonMargin: spacing.small,
    hintMargin: spacing.xSmall,
    createBlankTextWeight: typography.fontWeightBold,
    createBlankHotkeyTextWeight: typography.fontWeightNormal,
    createBlankHotkeyTextSize: typography.fontSizeXSmall,
    createBlankHotkeyTextPadding: spacing.xSmall
  };
};
export default generateComponentTheme;